import React from 'react';
import { Spinner } from '..';

export const FullScreenLoader = (): JSX.Element => {
    return (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <Spinner />
        </div>
    );
};
